import 'leaflet-lasso';

import { PanTool as PanMapTool } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import clsx from 'clsx';
import { MapContext, useKineticMap } from 'components/maps/MapContext';
import React, { memo, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useHotKey } from 'kineticUtils/hooks';
import { MapTool } from '../const';
import useLayersToolbarStyles from '../styles';
import { PanToolProps } from './types';

export const PanTool: React.FunctionComponent<PanToolProps> = () => {
  const { t } = useTranslation('app');
  const classes = useLayersToolbarStyles();

  const { setDragEnabled } = useKineticMap();

  const { activeMapTool, setActiveMapTool } = useContext(MapContext);
  const isActive = activeMapTool === MapTool.PAN;

  useEffect(() => {
    setDragEnabled(isActive);
  }, [isActive, setDragEnabled]);

  useHotKey({ key: 'p', alt: true, ctrl: true, callback: () => setActiveMapTool(MapTool.PAN) });

  return (
    <Tooltip title={t('panTool')}>
      <IconButton
        className={clsx(classes.button, { [classes.buttonActive]: isActive })}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setActiveMapTool(MapTool.PAN);
        }}
        sx={{ padding: '10px' }}
      >
        <PanMapTool fontSize='small' />
      </IconButton>
    </Tooltip>
  );
};

export default memo(PanTool);
